import { RidangoReduxAction } from '@ridango/core';

import { CustomerAuthActions } from './customer-auth.actions';

export interface CustomerAuthState {
    data: any;
    isCookiesAccepted: boolean;
}

export const CUSTOMER_AUTH_INITIAL_STATE = {
    data: null,
    isCookiesAccepted: false
};

export function customerAuthReducer(
    state: CustomerAuthState = CUSTOMER_AUTH_INITIAL_STATE,
    action: RidangoReduxAction
): CustomerAuthState {
    switch (action.type) {
        case CustomerAuthActions.CUSTOMER_LOAD_DATA:
            return {
                ...state,
                data: action.payload
            };

        case CustomerAuthActions.COOKIE_NOTIFICATION_ACCEPT:
            return {
                ...state,
                isCookiesAccepted: action.payload
            };
    }

    return state;
}
